import { getInstrument, historicalApiHost } from '../../config.js';

let availableSymbols = null;

export async function sortBars(bars) {
    bars.sort((a, b) => a.time - b.time);
    return bars
}

export function getParams() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams;
}

export function removeTrailingSlash(uri) {
    if (uri.charAt(uri.length - 1) === '/') {
        return uri.slice(0, -1);
    } else {
        return uri;
    }
}

export async function getSymbolsViaApi() {
    const params = getParams()
    let identifier = params.get("identifier");
    let user_id = params.get("user_id");
    try {
        const url = getInstrument[identifier];
        const payload = {
            "userId": user_id,
        };
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        };
        const response = await fetch(url, options)
        if (!response.ok) {
            console.error("Network response was not ok")
            return null;
            // throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error(`request error: ${error}`)
        return null;
        // throw new Error(`request error: ${error.status}`);
    }
}

export async function getAllSymbols() {

    if (availableSymbols === null) {
        availableSymbols = await getSymbolsViaApi()
    }

    if (availableSymbols === null) return null;

    const allSymbols = availableSymbols.map(symbol => {
        return {
            id:symbol.id,
            symbol: symbol.symbol,
            full_name: symbol.full_name,
            description: symbol.description,
            exchange: '',
            type: symbol.type,
            tradeTo: symbol.tradeTo,
            tradeFrom: symbol.tradeFrom,
            closingTimes: symbol.closingTimes
        }
    });
    return allSymbols;
}

export async function getHistoricalDataFromApi(symbol, requestedFromTime) {
    try {
        const params = getParams()
        const apiHost = historicalApiHost[params.get("identifier")]
        const response = await fetch(`${apiHost}/CandleData/CandleRequest?Name=${symbol}&FromDate=${requestedFromTime}`);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`HistoricalApi request error: ${error.status}`);
    }
}

export function getConvertedTradingTimes(tradingFromTime, tradingToTime) {

    const daysOfWeek = {
        Sunday: '1',
        Monday: '2',
        Tuesday: '3',
        Wednesday: '4',
        Thursday: '5',
        Friday: '6',
        Saturday: '7',
    };
    const fromParts = tradingFromTime.split(' - ');
    const toParts = tradingToTime.split(' - ');
    let fromDay = daysOfWeek[fromParts[0].trim()];
    let toDay = daysOfWeek[toParts[0].trim()];
    const fromTime = fromParts[1].trim();
    const toTime = toParts[1].trim();

    const formatTime = (time) => {
        const [timePart, period] = time.split(' ');
        const [hours, minutes] = timePart.split(':');
        let newHours = parseInt(hours, 10);
        if (period && period.toLowerCase() === 'pm' && newHours !== 12) {
            newHours += 12;
        } else if (period && period.toLowerCase() === 'am' && newHours === 12) {
            newHours = 0;
        }
        return `${String(newHours).padStart(2, '0')}${minutes}`;
    };

    const formattedFromTime = formatTime(fromTime);
    const formattedToTime = formatTime(toTime);

    if (toDay === fromDay) {
        toDay = parseInt(toDay) + 6;
    }

    const daysInBetween = Array.from(
        { length: toDay - fromDay + 1 },
        (_, index) => String(Number(fromDay) + index)
    );

    const formattedString = `${formattedFromTime}-${formattedToTime}:${daysInBetween.join('')}`;
    return formattedString;
}

export async function getHistoricalData(symbol, requestedFromTime, requestToTime) {
    try {
        const params = getParams()
        const apiHost = historicalApiHost[params.get("identifier")]
        const response = await fetch(`${apiHost}/CandleData/CandleRequest?Name=${symbol}&FromDate=${requestedFromTime}&ToDate=${requestToTime}`);
        if (!response.ok) {
            console.error(`HTTP error! Status: ${response.status}`)
            return [];
            // throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(`HistoricalApi request error: ${error.status}`)
        return [];
        // throw new Error(`HistoricalApi request error: ${error.status}`);
    }

}

export { availableSymbols }
